module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAJCAYAAADpeqZqAAAAsklEQVQoU43RoUpEQRQG4O/HuCKIb7BZsGkzmG1bfIoNgk0sYhF8DatREIw2y1rEZzCu2PTIyL1ylXXZaXPO+eacmQlU1Tq2sdb2/6wPPCV5T1Xt4B5bS0CfesV+Qye4XAH0JdOGNvGI8QrwBbvp7tRGfMBoCZxjL8nzN+rgEa7xExscUJgkuWmxXwVVdYXjBd0ukpz28b+oPfkdDgbwFodJPheibswNnHX/NsN5krdh9y+WIjGkmwpIvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/energy/jt.png
// module id = hxb1
// module chunks = 3